<template>
	<div>
		<modal index="11997" name="cp-modal-desativar">
			<div class="row">
				<div class="col-md-12">
					<h4>
						{{ textoBotao }}
					</h4>
				</div>
			</div>

			<hr style="margin-top: 0px; margin-bottom: 10px" />

			<div class="row">
				<div class="col-xs-12 text-center" v-html="texto"></div>
			</div>

			<hr style="margin-top: 20px; margin-bottom: 10px" />

			<div class="row">
				<div class="col-xs-6">
					<button
						class="btn btn-default pull-left"
						type="button"
						@click="clickFechar()"
					>
						<i class="fa fa-times"></i>
						{{ _traducao('global', 'fechar').toUpperCase() }}
					</button>
				</div>

				<div class="col-xs-6">
					<button
						class="btn btn-success pull-right"
						type="button"
						@click="clickDesativar()"
					>
						<i class="fa fa-check"></i> {{ textoBotao }}
					</button>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
export default {
	data() {
		return {
			texto: '',
			textoBotao: ''
		}
	},

	mounted() {
		bus.$on('cp-carrega-modal-desativar', (texto, textoBotao) => {
			this.texto = texto
			this.textoBotao = textoBotao
			this._exibeModal('cp-modal-desativar', 60)
		})
	},

	methods: {
		clickFechar() {
			this._escondeModal('cp-modal-desativar')
			bus.$emit('cp-modal-desativar-fechou')
		},

		clickDesativar() {
			this._escondeModal('cp-modal-desativar')
			bus.$emit('cp-modal-desativar-desativar')
		}
	}
}
</script>